var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',[_vm._t("default")],2):_c('v-card',{staticClass:"d-flex align-center justify-center",attrs:{"height":"65vh","flat":""}},[_c('v-progress-circular',{attrs:{"color":_vm.color,"size":50,"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }